<template>
  <div>
    <el-card>
      <div id="in-sheet">
        <div class="top-btn-group">
          <div class="top-btn-danju">
            单据（ 制单前请先在基础库导入商品，并在 <strong class="el-icon-top-left" style="font-size:24px;color:red;"></strong> 选择好店铺 ）
          </div>
          <div>
            <el-button size="small" @click="openExcel">导入信息</el-button>
            <el-button size="small" type="primary" @click="submit">制单</el-button>
          </div>
        </div>
        <!-- 表头部信息 -->
        <div class="documents_head">
          <div :class="danju_class">单据信息</div>
          <el-form :model="header_info" label-width="80px">
            <el-row class="el-row-1" :gutter="10">
              <!-- <el-col :span="6"> 制单人：{{ header_info.create_id }} </el-col> -->
              <el-col :span="7">
                销售方：{{header_info.buyer_no}}
              </el-col>
              <el-col :span="7">
                购买方：
                <el-select
                  size="mini"
                  v-model="header_info.vendor"
                  filterable
                  placeholder="选择店铺"
                >
                  <el-option
                    v-for="item in vendor_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select> </el-col
              ><el-col :span="7">
                结账日期：
                <el-date-picker
                  v-model="header_info.settle_date"
                  type="date"
                  size="mini"
                  placeholder="选择日期"
                >
                </el-date-picker>
              </el-col>
              <el-col :span="3">
                时间：
                <div class="block">
                  {{ header_info.createDate }}
                </div>
              </el-col>
            </el-row>
            <el-row class="el-row-2">
              <el-col :span="5">
                金额：
                <span style="color:red;display:inline-block;">{{
                  header_info.amount
                }}</span>
                <i v-if="header_info.amount" style="margin-left:10px"> 元</i>
              </el-col>
              <el-col :span="5">
                折扣金额：
                <span style="color:red;display:inline-block;">{{
                  header_info.discount_amount
                }}</span>
                <i v-if="header_info.discount_amount" style="margin-left:10px"
                  >元</i
                >
              </el-col>
              <el-col :span="5">
                数量：
                <span style="color:blue;display:inline-block;">{{
                  header_info.quantity
                }}</span>
              </el-col>

              <el-col :span="7">
                单据类型：
                <el-select
                  size="mini"
                  v-model="header_info.vendor"
                  filterable
                  placeholder="选择店铺"
                >
                  <el-option
                    v-for="item in vendor_list"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div>
          <ve-table
            v-if="tableDataShow"
            border-x
            border-y
            ref="tableRef"
            style="width:100%"
            :scroll-width="1500"
            edit="true"
            :max-height="mainH"
            :footer-data="footerData"
            :editOption="editOption"
            :fixed-header="true"
            row-key-field-name="flow_no"
            :row-style-option="rowStyleOption"
            :event-custom-option="eventCustomOption"
            :border-around="true"
            :columns="columns"
            :table-data="tableData"
            :cell-style-option="cellStyleOption"
          />
        </div>
      </div>
    </el-card>
    <excel
      ref="excel"
      @update-import="updateTableData"
      @cover-import="CoverTableData"
      >更新并导入
    </excel>
  </div>
</template>
<script>
import { generateSheet, baseGoodsQuery } from "@/api/baseinfo";
import { timeFun,deleteTabRepeat } from "@/js/public";
import excel from "@/components/excel.vue";
export default {
  name: "tablecard",
  components: { excel },
  data() {
    return {
      //点击时候的row
      row_data: {},
      //导入数据时
      tableDataShow: true,
      danju_class: "",
      // 单据表头信息
      header_info: {
        create_id: "",
        // document_id: "In-YLM-2022-7-18-15",
        createDate: this.requestDate(), //创建时间
        buyer_no: window.localStorage.getItem('mch_id'), //购买方
        saler_no: "", //销售方
        quantity: 0, //合计数量
        amount: 0, //合计金额
        discount_amount: 0, //折扣金额
        settle_date: "", //结账日期
        sheet_type: "", //单据类型
        access_token: ""
      },
      // 店鋪列表列表
      vendor_list: [
        {
          label: "美琪",
          value: "1"
        },
        {
          label: "天玄",
          value: "2"
        },
        {
          label: "地理",
          value: "3"
        },
        {
          label: "物理",
          value: "4"
        },
        {
          label: "历史",
          value: "5"
        },
        {
          label: "化学",
          value: "6"
        },
        {
          label: "日照宁飞商贸盼盼食品代理",
          value: "7"
        }
      ],
      // 主体表格的表头
      columns: [
        {
          field: "",
          key: "a",
          title: "",
          width: 30,
          fixed: "left",
          align: "center",
          operationColumn: true,
          renderBodyCell: ({ row, column, rowIndex }, h) => {
            return ++rowIndex;
          }
        },
        {
          field: "barcode",
          key: "barcode",
          title: "商品条码",
          align: "left",
          width: 100,
          edit: true,
          fixed: "left",
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "item_name",
          key: "item_name",
          title: "商品名称",
          align: "left",
          fixed: "left",
          width: 100,
          edit: true,
          ellipsis: {
            showTitle: true
          }
        },
        {
          field: "class_no",
          key: "class_no",
          title: "类别",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "batch_no",
          key: "batch_no",
          title: "批次号",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "advise_price",
          key: "advise_price",
          title: "建议售价",
          align: "left",
          width: 100,
          edit: true
        },
        {
          field: "expire_time",
          key: "expire_time",
          title: "保质期",
          align: "left",
          width: 200,
          edit: true
        },
        {
          field: "item_size",
          key: "item_size",
          title: "规格",
          align: "left",
          width: 100,
          edit: false
        },
        {
          field: "flag",
          key: "flag",
          title: "标识",
          align: "left",
          width: 100,
          edit: false
        },
        {
          field: "price",
          key: "price",
          title: "价格",
          align: "left",
          fixed: "right",
          width: 100,
          edit: true
        },
        {
          field: "qty",
          key: "qty",
          title: "数量",
          align: "left",
          fixed: "right",
          width: 100,
          edit: true
        },

        {
          field: "amount",
          key: "amount",
          title: "金额",
          align: "left",
          width: 100,
          fixed: "right",
          edit: false
        }
      ],
      // edit option 修改后的返回值
      editOption: {
        // cell value change
        cellValueChange: ({ row, column }) => {
          this.row_data = row;
          this.zero(this.tableData);
          this.compute();
          this.getSum();
          this.computeReady(this.tableData);
        }
      },
      cellStyleOption: {
        bodyCellClass: ({ row, column, rowIndex }) => {
          if (rowIndex == 0) {
            return "table-body-cell-class";
          } else if (rowIndex == 1) {
            return "table-body-cell-class-green";
          } else if (rowIndex == 2) {
            return "table-body-cell-class-red";
          }
        }
      },
      //
      rowStyleOption: {
        clickHighlight: false,
        hoverHighlight: false
      },
      // 主表高度
      mainH: "400px",
      // 自定义的单机事件
      eventCustomOption: {
        bodyCellEvents: ({ row, column, rowIndex }) => {
          return {
            click: event => {
              this.delete_Goods = [];
              this.delete_Goods.push(row.barcode);
              //   console.log("click::", row, column, rowIndex, event);
            }
          };
        }
      },
      footerData: [],
      tableData: [
        {
          barcode: "69019232111",
          item_name: "测试",
          flow_no: "1",
          price: "1.90",
          advise_price: "2.8",
          other1: "测试",
          other2: "test",
          qty: "10",
          amount: "57",
          class_no: "10",
          flag: "00",
          item_size: "300g",
          batch_no: "20230311",
          expire_time: ["2024-04-11, 10"]
        }
      ]
      /*  //金额合计
      sumNumber:0,
      //数量合计
      count_num:0, */
    };
  },
  created() {
    this.zero(this.tableData);
    this.computeReady(this.tableData);
    this.getSum();
    this.assignRowKey();
    // this.insertEmptyLine();
  },
  mounted() {
    var resolution = localStorage.getItem("pixel");
    if (resolution <= 700 * 900) {
      this.mainH = "200px";
      this.danju_class = "danju-small";
    }
    if (resolution > 700 * 900 && resolution < 1400 * 900) {
      this.mainH = "300px";
      this.danju_class = "danju-middle";
    }
    if (resolution > 1400 * 900) {
      this.mainH = "400px";
      this.danju_class = "danju";
    }
  },
  methods: {
    //打开表格工具
    openExcel() {
      this.$refs.excel.showModel();
    },
    //rowkey
    assignRowKey() {
      this.tableData.forEach(function(item, i, arr) {
        arr[i].flow_no = i;
        arr[i].batch_no = timeFun("count_dd");
      });
    },
    //加一个空行
    insertEmptyLine() {
      this.tableData.unshift({
        barcode: "",
        item_name: "",
        flow_no: "",
        price: 0,
        advise_price: "",
        qty: 0,
        amount: 0,
        class_no: "",
        flag: "",
        item_size: "",
        batch_no: "",
        expire_time: ""
      });
      this.assignRowKey();
    },
    // 页脚
    initFooterData() {
      this.footerData = [
        {
          flow_no: "999999999",
          barcode: "合计",
          item_name: "",
          price: "",
          qty: this.count_num,
          amount: this.sumNumber
        }
      ];
    },
    //计算金额
    computeReady(data) {
      data.forEach(function(item, i, arr) {
        arr[i].amount = Number(arr[i].price) * Number(arr[i].qty);
      });
    },
    // 合计值计算
    getSum() {
      this.sumNumber = 0;
      this.count_num = 0;
      for (var j = 0; j < this.tableData.length; j++) {
        this.sumNumber += Number(this.tableData[j].amount);
        this.count_num += Number(this.tableData[j].qty);
      }
      this.sumNumber = Number(
        this.sumNumber.toString().match(/^\d+(?:\.\d{0,4})?/)
      );
      this.header_info.amount = this.sumNumber;
      this.header_info.quantity = this.count_num;
      this.initFooterData();
    },
    zero(data) {
      data.forEach(function(item, i, arr) {
        if (item.price == "" || item.price.length == 0 || !item.price) {
          arr[i].price = 0;
        }
        if (item.qty == "" || item.qty.length == 0 || !item.qty) {
          arr[i].qty = 0;
        }
      });
    },
    // 输入后计算金额
    compute() {
      var that = this;
      this.tableData.forEach(function(item, i, arr) {
        if (arr[i].barcode == that.row_data.barcode) {
          arr[i].amount =
            Number(that.tableData[i].price) * Number(that.tableData[i].qty);
        }
      });
    },
    updateTable() {
      console.log("tablecard组件:");
    },
    // 覆盖并导入数据
    CoverTableData(val) {},
    //更新并导入商品
    async updateTableData(val) {
      console.log("val:",val);
      this.tableDataShow = false;
      var mtable = [];
      var detable = [];
      var newtab = [];
      var newnewtab=[];
      // var
      //循环所有表格上传的数组
      for (var i = 0; i < val.length; i++) {
        //查找每一个数组元素的barcode，看看在tableDate是否已经存在
        var _index = this.tableData.findIndex(x => x.barcode == val[i].barcode);
        //如果已存在 将表数据覆盖为导入值
        if (_index > -1) {
          mtable.push({
            barcode: val[i].barcode,
            item_name: this.tableData[_index].item_name,
            flow_no: 1,
            price: val[i].price,
            advise_price: this.tableData[_index].advise_price,
            qty: val[i].qty,
            amount: 0,
            class_no: val[i].class_no ? val[i].class_no : "",
            flag: "",
            item_size: this.tableData[_index].item_size,
            batch_no: "",
            expire_time: val[i].expire_time
          });
          //保存重复的值，等待删除操作
          detable.push(this.tableData[i].barcode);
        } else {
          //如果tableData中不存在查询基础库
          const res = await baseGoodsQuery(val[i].barcode);
          console.log("res:--------------------------------", res);
          //如果基础库中不存在
          if (res == [] || res == false) {
            newnewtab.push({
              barcode: val[i].barcode,
              item_name: val[i].item_name ? val[i].item_name : "",
              flow_no: "",
              price: val[i].price,
              advise_price: val[i].advise_price ? val[i].advise_price : 0,
              qty: val[i].qty,
              amount: 0,
              class_no: val[i].class_no ? val[i].class_no : "",
              flag: "",
              item_size: val[i].item_size ? val[i].item_size : "",
              batch_no: "",
              expire_time: val[i].expire_time
            });
            //如果基础库中存在 存在一条或者多条，先考虑一条的情况，多条先不考虑
          } else if (res.length >= 1 && res != false) {
            newtab.push({
              barcode: val[i].barcode,
              item_name: res[0].item_name ? res[0].item_name : "",
              flow_no: "",
              price: val[i].price,
              advise_price: res[0].advise_price ? res[0].advise_price : 0,
              qty: val[i].qty,
              amount: 0,
              class_no: val[i].class_no ? val[i].class_no : "",
              flag: "",
              item_size: res[0].item_size ? res[0].item_size : "",
              batch_no: "",
              expire_time: val[i].expire_time
            });
          }
          // val[i].flow_no = this.tableData.length;
          // this.tableData.push(val[i]);
        }
      }
      //去除掉原来表中相同的商品
      this.tableData = deleteTabRepeat(detable, this.tableData, "barcode");
      //向表格中导入最新的商品信息
      for (let i = 0; i < mtable.length; i++) {
        this.tableData.push(mtable[i]);
      }
      //向表最上面导入库中有超市没有的商品
      for (let i = 0; i < newtab.length; i++) {
        this.tableData.unshift(newtab[i]);
      }
      //向表最上面导入库中没有的商品
      for (let i = 0; i < newnewtab.length; i++) {
        this.tableData.unshift(newnewtab[i]);
      } 
      //将必须要的值置零
      this.zero(this.tableData);
      //设置行号
      await this.assignRowKey();
      await this.computeReady(this.tableData);
      await this.getSum();
      this.tableDataShow = true;
    },

    //提交表单
    async submit() {
      this.header_info = {
        create_id: window.localStorage.getItem("user_id"),
        // document_id: "In-YLM-2022-7-18-15",
        createDate: this.requestDate(), //创建时间
        buyer_no: "123444", //购买方
        saler_no: "111111", //销售方
        discount_amount: 0, //折扣金额
        settle_date: "2023-10-22", //结账日期
        sheet_type: "10", //单据类型
        access_token: window.localStorage.getItem("access_token")
      };
      console.log(
        JSON.stringify({ ...this.header_info, detail: this.tableData })
      );
      const res = await generateSheet({
        ...this.header_info,
        detail: this.tableData
      });
      console.log("返回值：", res);
    },
    /* //删除选出的值 传两个数组 arr1存放 arr2需要删除的值 arr2是需要修改的数组 key存放arr2某一项的标识
    deleteTabRepeat(arr1, arr2, key) {
      const all_arr = [];
      const mo_arr = [];
      for (let i = 0; i < arr2.length; i++) {
        all_arr.push(arr2[i]);
      }
      for (let j = 0; j < all_arr.length; j++) {
        if (arr1.indexOf(all_arr[j][key]) < 0) {
          mo_arr.push(all_arr[j]);
        }
      }
      return mo_arr;
    } */
  }
};
</script>
<style lang="less">

.top-btn-group {
  height: 50px;
  background-color: #fff;
  padding: 0 0 10px 0;
  text-align: right;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .top-btn-danju {
    height: auto;
    width: auto;
    border-left: 5px solid #ffbb72;
    padding-left: 20px;
    // color:rgb(53, 53, 53);
    font-weight: 700;
  }
}

.table-body-cell-class {
  background: #91d5ff !important;
  /* color: #fff !important; */
}
.table-body-cell-class-green {
  background: #ffbb72 !important;
  /* color: rgb(255, 255, 255) !important; */
}
.table-body-cell-class-red {
  background: #ffaeae !important;
  color: rgb(255, 0, 0) !important;
}
#in-sheet {
  width: 100%;
  height: 100%;
}
/* .el-row-2 {
  margin-top: 10px;
} */
.el-row-1 {
  margin-top: 10px;
}
.block {
  display: inline-block;
}
.danju {
  height: 60px;
  line-height: 3;
  background-color: rgba(4, 138, 247, 0.418);
  text-align: center;
  font-size: 20px;
}
.danju-middle {
  height: 40px;
  line-height: 3;
  background-color: rgba(4, 138, 247, 0.418);
  text-align: center;
  font-size: 16px;
}
.danju-small {
  height: 30px;
  line-height: 2;
  background-color: rgba(4, 138, 247, 0.418);
  text-align: center;
  font-size: 12px;
}

.el-card {
  margin: 10px 10px 0 10px;
}
.el-col {
  height: 40px;
  line-height: 2;
}
</style>
